
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn'; 
import contact_data from '../data/contact_info.json'
import { IconNotProvided,  IconLink, TikTokIcon, DPopIcon, EtsyIcon, KoFiIcon } from './Template'
import React from "react";
import './social_media_links.css' 

export function AccountIcon({platform, color, scale}) {
    
    const mapStyle = () => {
        const styles = {}
        if (color) {
            styles['color'] = color
        }
        return styles
    }

    switch(platform) {
        case 'tiktok':
            return <TikTokIcon color={color} className="medium-icon" />
        case 'etsy':
            return <EtsyIcon color={color} className="medium-icon" />
        case 'facebook':
            return <FacebookIcon style={mapStyle()} className="medium-icon" />
        case 'instagram':
            return <InstagramIcon style={mapStyle()} className="medium-icon" />
        case 'youtube':
            return  <YouTubeIcon style={mapStyle()} className="medium-icon" /> 
        case 'linkedin':
            return <LinkedInIcon style={mapStyle()} className="medium-icon" /> 
        case 'depop':
            return <DPopIcon color={color}  />
        case 'kofi':
            return <KoFiIcon color={color}  />
        case 'venmo': 
            return <IconNotProvided iconName={platform} />
        default:
            return <IconNotProvided iconName={platform} />
    }
}
 

export function socialMediaLinksGenerator() {
    const accounts = contact_data.accounts.filter(x=> x.privateInd == false)
    return accounts.map(x => <IconLink url={x.url} >
            <AccountIcon platform={x.platform} color={"#ffffff"} />
        </IconLink>)
}


export function SocialsIconListItems({ children }) {
    return (
       <React.Fragment>
        { socialMediaLinksGenerator().map(child => <li className="icon-links-list">{child}</li>) }
       </React.Fragment>
    )
}
 